export default __webpack_public_path__ + "media/images/advan-icon/cursor-33cff549b60905a44085cc71a9dae105.png";